export enum USER_FILE_CATEGORY {
  CCB = 'CCB',
  ILF_REPORT = 'ILF_REPORT',
}

export class UserFile {
  id: string;
  filename: string;
  bucket: string;
  key: string;
  category: USER_FILE_CATEGORY;

  constructor(data: string | UserFile | DjangoUserFile = {}) {
    if (typeof data === 'string') {
      bindConstructorDataToInstance(this, { id: data });
    } else {
      bindConstructorDataToInstance(this, data);
    }
  }
}

export class DjangoUserFile {
  id?: string;
  filename?: string;
  bucket?: string;
  key?: string;
  category?: USER_FILE_CATEGORY;
}

///////////////
/// PRIVATE ///
///////////////
function bindConstructorDataToInstance(instance: UserFile, data: UserFile | DjangoUserFile) {
  const jsData = bindDjangoPropsToJs(data);
  instance.id = jsData.id;
  instance.filename = jsData.filename;
  instance.bucket = jsData.bucket;
  instance.key = jsData.key;
  instance.category = jsData.category;
}

function bindDjangoPropsToJs(data: UserFile | DjangoUserFile) {
  const djangoData = data as DjangoUserFile;
  const jsData = data as UserFile;
  return {
    ...data,
  } as UserFile;
}

export function parseUserFile(data?: string | UserFile | DjangoUserFile) {
  if (data) {
    return new UserFile(data);
  } else {
    return undefined;
  }
}
